import * as React from "react";
import styled from "styled-components";
import Header from "../components/header/index";
import LeftText from "../components/laEmpresa/leftText";
import RightText from "../components/laEmpresa/rightText";
import SeguroParaTodos from "../components/footer/seguroParaTodo";
import Footer from "../components/footer/index";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;
  background-color: var(--white);
  overflow: hidden;
`;

export default function SobreNosotros() {
  return (
    <Container>
      {/* Header */}
      <Header></Header>
      {/* Principal Title and Quienes somos */}
      <LeftText
        title="La empresa"
        subTitle="¿Quiénes somos?"
        text="SeguroBici es una marca registrada de la compañía Gestión y Servicios SRL Bróker de Seguros multiproductos que se especializa en el asesoramiento y venta de Seguros por Internet. La Compañía existe desde 1988 y nuestros 28 años de experiencia respaldan nuestro rendimiento en el Mercado de Seguros. SeguroBici comercializa Seguros Online por medio de un multicotizador que permite comparar compañías y coberturas."
        image="images/nosotros/ilustration1.svg"
      ></LeftText>
      {/* Nuestros Objetivos */}
      <RightText
        subTitle="Nuestros Objetivos"
        text={[
          "Mantener al Cliente satisfecho a través de la mejor Calidad de Servicio, en Cotización y Contratación Online de Seguros, Gestión de Siniestros y Atención Personalizada.",
          <br></br>,
          <br></br>,
          "¿Cómo lo hacemos? Contamos con la experiencia y la eficiencia como pilares fundamentales, conjuntamente con un importante avance tecnológico, lo que avala la propuesta para que usted y sus clientes puedan sentirse plenamente respaldados.",
        ]}
        image="images/nosotros/ilustration2.svg"
      ></RightText>
      {/* Visión Comercial */}
      <LeftText
        subTitle="Visión Comercial"
        text={[
          "Vivimos en un mundo en permanente cambio y SeguroBici es la demostración de esto para Gestión y Servicios SRL. En un mercado tradicional como lo es el asegurador, el avance de la tecnología y las modificaciones del comportamiento de los consumidores han posibilitado la llegada de la Venta de Seguros en plataformas Web.",
          <br></br>,
          <br></br>,
          "SeguroBici, pionero en la Venta de Seguros por Internet, se posiciona hoy como líder de este canal. Permitiendo constantemente la realización de nuevos Seguros.",
        ]}
        image="images/nosotros/ilustration1.svg"
      ></LeftText>
      {/* ¿Qué hemos logrado? */}
      <RightText
        subTitle="¿Qué hemos logrado?"
        text={[
          "Contamos con más de 32.000 pólizas vigentes.",
          <br></br>,
          <br></br>,
          "Trabajamos con 23 Compañías de Seguros, incluyendo a las más importantes del país como Federación Patronal, ATM, Libra Seguros, Profru Seguros y Mapfre, entre muchísimas otras.",
          <br></br>,
          <br></br>,
          "Hemos logrado desarrollar una gran comunidad por medio de nuestras redes sociales, como así también por nuestro blog y campañas de email marketing con más de 40.000 participantes.",
        ]}
        image="images/nosotros/ilustration2.svg"
      ></RightText>
      {/* Seguros para todos */}
      <SeguroParaTodos></SeguroParaTodos>
      {/* Footer */}
      <Footer></Footer>
    </Container>
  );
}
